import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import RoutableSitecoreLink from '../../@shared/routableSitecoreLink';
import { useMenuDispatcher } from './menuContext';
import { IComponentFieldsGeneral } from '../../../types/types';
import Icon from '../../@shared/icon';
import { iconSize } from '../../../constants/icon.constants';
import { googleNavClickEvent } from '../../../utils/analytics';
import { topIconMenu } from '../../../constants/analytics.constants';

const FindADealer = ({ fields }: { fields: IComponentFieldsGeneral }) => {
  const dispatchToProvider = useMenuDispatcher();
  const handleClick = () => {
    dispatchToProvider({ type: 'closeAll' });
  };

  return (
    <li className="navigation__menu-item">
      <RoutableSitecoreLink
        field={fields?.findDealer?.link}
        onClick={() => {
          googleNavClickEvent(topIconMenu, fields?.findDealer?.link?.value?.href, fields?.findDealer?.title?.value);
          handleClick();
        }}
        className="navigation__menu-item__trigger"
      >
        <span className="navigation__menu-item__trigger__content navigation__menu-item__trigger__content--with-icon">
          <Icon
            iconField={fields?.findDealer?.icon}
            size={iconSize.dsk}
            extraClassName="navigation__menu-item__trigger__icon"
            color="primary"
          />
          <RichText tag="div" className="navigation__menu-item__trigger__text rich-text" field={fields?.findDealer?.title} />
        </span>
      </RoutableSitecoreLink>
    </li>
  );
};

export default FindADealer;
